export default __webpack_public_path__ + "static/media/safari.ecfc42f5.jpg";